module.exports = __webpack_public_path__ + "img/avatar7.f94a01a9.png";